// extracted by mini-css-extract-plugin
export default {"block":"styles_block__Y5y8Q","steps":"styles_steps__pBEZu","progress":"styles_progress__mykGq"};